export interface UserCategoriesPage {
  activeTabIndex: number;
}

export interface UserCategoriesState {
  userCategoriesPage: UserCategoriesPage
}

export function createInitialUserCategoriesState(): UserCategoriesState {
  return {
    userCategoriesPage: {
      activeTabIndex: 0
    }
  }
}